import { cn } from '@/lib/cn';

interface TabsProps<T extends string> {
  tabs: ReadonlyArray<{ value: T; label: string; count?: number }>;
  value: T;
  onChange: (value: T) => void;
  className?: string;
}

/** Text tabs on a hairline; the active tab carries a 2px gold rule. */
export function Tabs<T extends string>({ tabs, value, onChange, className }: TabsProps<T>) {
  return (
    <div role="tablist" className={cn('flex flex-wrap gap-[26px] border-b border-line', className)}>
      {tabs.map((tab) => {
        const active = tab.value === value;
        return (
          <button
            key={tab.value}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(tab.value)}
            className={cn(
              'shrink-0 whitespace-nowrap pb-3 font-mono text-[10px] uppercase tracking-[0.16em]',
              active ? 'text-ink shadow-[inset_0_-2px_0_var(--accFill)]' : 'text-mute hover:text-ink'
            )}
          >
            {tab.label}
            {tab.count !== undefined && <span className="text-faint"> {tab.count}</span>}
          </button>
        );
      })}
    </div>
  );
}
